module.exports = __webpack_public_path__ + "img/request-kits-sample-cards.d60ac2d1.png";